import { RouteConfig } from "vue-router";
import { RNotificationsBrowse } from "@/modules/Notifications/views/browse/RNotificationsBrowse";
import { RNotificationsTemplate } from "@/modules/Notifications/views/template/RNotificationsTemplate";

export const REmployerNotifications: RouteConfig = {
  path: "notifications",
  component: () =>
    import(
      /* webpackChunkName: "employer-notifications" */
      "./VEmployerNotifications.vue"
    ),
  children: [RNotificationsBrowse, RNotificationsTemplate],
};
